import React from "react";
import { cn } from "./cn";

/**
 * Encabezado de página: el H1 vive acá y no en la barra superior, para que la
 * jerarquía sea barra (contexto) → título (dónde estoy) → contenido (datos).
 */
export interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions,
  className,
}) => (
  <div
    className={cn(
      "flex flex-col gap-3 pb-5 pt-6 sm:flex-row sm:items-end sm:justify-between sm:pb-6 sm:pt-7",
      className
    )}
  >
    <div className="min-w-0">
      <h1 className="text-[26px] font-bold leading-tight text-gray-900 dark:text-white sm:text-[28px]">
        {title}
      </h1>
      {description ? (
        <p className="mt-1.5 max-w-[62ch] text-sm leading-relaxed text-gray-700 dark:text-gray-400">
          {description}
        </p>
      ) : null}
    </div>

    {actions ? (
      <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
        {actions}
      </div>
    ) : null}
  </div>
);

export default PageHeader;
